var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.53 14.804C23.323 12.444 19.666 9.95 16 10c-3.669-.051-7.326 2.444-9.53 4.803a1.756 1.756 0 000 2.39C8.647 19.528 12.253 22 15.864 22h.257c3.624 0 7.228-2.472 9.41-4.807.625-.68.624-1.71-.003-2.39zM12.164 16c0-2.06 1.717-3.73 3.834-3.73 2.118 0 3.835 1.67 3.835 3.73S18.117 19.73 16 19.73c-2.117 0-3.834-1.67-3.834-3.73zm3.834 1.622c.921 0 1.668-.726 1.668-1.622 0-.895-.747-1.621-1.668-1.621-.92 0-1.667.726-1.667 1.621 0 .896.747 1.622 1.667 1.622z",
    fill: "#005FFF"
  })));
};

export default SvgEye;